module.exports = __webpack_public_path__ + "img/m1.a8c6948a.jpg";